import $ from 'jquery';
import { getClosestByEventPath } from './utils.js';

const getClosestElement = function($element, classname) {
    let $_element = $element.parentElement;

    while($_element) {
        if($_element.classList.contains(classname)) {
            return $_element;
        }

        $_element = $_element.parentElement;
    }

    return null;
}

export default function() {
    const $lists  = document.querySelectorAll('.js-catalog-list');
    const $filterButton = document.querySelector('.js-catalog-list-filter-button');
    const selectedSet = new Set();

    $lists.forEach(($list) => {

        $list.addEventListener('click', function(e) {
            const $itemLink = getClosestByEventPath(e, 'js-catalog-link');
            if ($itemLink) {
                return;
            }

            const $itemPane = getClosestByEventPath(e, 'js-catalog-list-pane');

            if ($itemPane) {
                const $button = $($itemPane).find('.js-catalog-list-pane-button-toggle').first();

                if ($button.length) {
                    const $item = getClosestElement($button[0], 'js-catalog-list-item');
                    if($item) {
                        $item.classList.toggle('_is-expanded');
                    }
                }
            }
        });

        $list.addEventListener('change', function(e) {
            if(e.target.tagName.toLowerCase() === 'input') {
                selectedSet[e.target.checked ? 'add' : 'delete'](e.target.value);
            }

            if ($filterButton) {
                $filterButton.classList[selectedSet.size ? 'remove' : 'add']('d-n');
            }
        });

        $list.querySelectorAll('input[type="checkbox"]').forEach(($checkbox) => {
            if($checkbox.checked) {
                selectedSet.add($checkbox.value);
            }
        });

        if ($filterButton) {
            $filterButton.classList[selectedSet.size ? 'remove' : 'add']('d-n');
        }
    });

    if($filterButton) {
        $filterButton.addEventListener('click', function(e) {
            e.preventDefault();

            const baseUrl = $filterButton.getAttribute('data-url');

            if(baseUrl) {
                let selectedIds = Array.from(selectedSet);
                if(selectedIds.length) {
                    window.location.href = baseUrl + `/${selectedIds.join(',')}`;
                }
            }
        });
    }
}
